import styled from '@emotion/styled'
import React from 'react'
import { IssueIcon } from '@instacart/ids-core'
import { colors, spacing } from '../../foundation'
import { Text } from '../text/Text'
import { useMessages } from '../../utils/intl/intl.hooks'

export const FormField = styled.div({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: spacing.X4,
  paddingBottom: spacing.X24,
})

export const FormFieldLabel: React.FunctionComponent<
  React.HTMLProps<'label'> & { optional?: boolean }
> = ({ children, optional, ...props }) => {
  const messages = useMessages({
    optional: 'sharedComponents.formField.optional',
  })

  return (
    <Text {...props} as="label" weight="semibold" size="medium">
      {children}

      {optional && (
        <Text css={{ display: 'inline', marginLeft: spacing.X4, color: colors.GRAYSCALE.X50 }}>
          {messages.optional}
        </Text>
      )}
    </Text>
  )
}

export const FormFieldDescription: React.FunctionComponent<{ className?: string }> = ({
  children,
  ...props
}) => (
  <Text {...props} size="small">
    {children}
  </Text>
)

export const FormFieldError: React.FunctionComponent<
  React.HTMLProps<'label'> & {
    icon?: React.ComponentType
  }
> = ({ children, icon: Icon = IssueIcon, ...props }) => (
  <div css={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: spacing.X4 }}>
    <Icon size={13} color="systemDetrimentalRegular" />

    <Text {...props} as="label" size="small" css={{ color: colors.DETRIMENTAL.REGULAR }}>
      {children}
    </Text>
  </div>
)
